import React from 'react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import styled from 'styled-components';
import farmerImage from '../Assets/template/farmers.jpg';
import damImage from '../Assets/template/benliw.png';
import handVideo from '../Assets/template/flowing2.gif';

const Footer = () => {
  return (
    <FooterContainer>
      {/* Farmer Image Section */}
      <Section bg={farmerImage} height="200px" />

      {/* Dam Image with Overlay Cards */}
      <Section bg={damImage} height="320px">
        <OverlayRow>
          <OverlayCard>
            <Title>Transparency</Title>
            <StyledLink href="#">About</StyledLink>
            <StyledLink href="#">Services</StyledLink>
            <StyledLink href="#">Activities</StyledLink>
          </OverlayCard>

          <OverlayCard>
            <Title>DISA</Title>
            <Text>
              DISA manages and enhances irrigation systems across the Philippines
              to improve agricultural productivity, support farmers, and ensure food security.
            </Text>
          </OverlayCard>

          <OverlayCard>
            <Title>Support</Title>
            <StyledLink href="#">Contact Us</StyledLink>
            <StyledLink href="#">FAQ</StyledLink>
            <StyledLink href="#">Live Chat</StyledLink>
          </OverlayCard>
        </OverlayRow>
      </Section>

      {/* GIF Background Section */}
      <VideoSection>
        <VideoBackground as="img" src={handVideo} alt="Background GIF" />

        <div style={{ textAlign: 'center', width: '100%', zIndex: 1 }}>
          <SocialIconsContainer>
            <SocialIcon><a href="https://facebook.com"><FaFacebook /></a></SocialIcon>
            <SocialIcon><a href="https://twitter.com"><FaTwitter /></a></SocialIcon>
            <SocialIcon><a href="https://instagram.com"><FaInstagram /></a></SocialIcon>
            <SocialIcon><a href="https://linkedin.com"><FaLinkedin /></a></SocialIcon>
          </SocialIconsContainer>

          <FooterBottom>
            <BottomText>&copy; 2025 DISA. All rights reserved.</BottomText>
            <BottomLinks>
              <StyledLink href="#">Terms & Conditions</StyledLink>
              <StyledLink href="#">Privacy Policy</StyledLink>
            </BottomLinks>
          </FooterBottom>
        </div>
      </VideoSection>
    </FooterContainer>
  );
};

export default Footer;

// ----- Styled Components -----

const FooterContainer = styled.footer`
  width: 100%;
  overflow: hidden;
  font-family: 'Segoe UI', sans-serif;
`;

const Section = styled.div`
  background-image: url(${props => props.bg});
  background-size: cover;
  background-position: ${props => props.bgPosition || 'center'};
  height: ${props => props.height};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${props => props.gap || '0'};

  &::before {
    content: '';
    background: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  & > * {
    position: relative;
    z-index: 1;
  }
`;

const OverlayRow = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
  padding: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const OverlayCard = styled.div`
  background-color: rgba(0, 0, 0, 0.10);  // <--- updated for lighter look
  padding: 20px;
  border-radius: 15px;
  color: white;
  width: 300px;
  height: 270px;
  margin: 10px;
  backdrop-filter: blur(2px);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  display: flex;
  flex-direction: column;
  align-items: center;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 768px) {
    width: 80%;
    height: auto;
  }
`;

const Title = styled.h4`
  font-weight: bold;
  font-size: 1.5rem;
  color: white;
  margin-bottom: 1rem;
  text-shadow: 1px 1px 2px black;
`;

const Text = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  text-shadow: 1px 1px 2px black;
`;

const StyledLink = styled.a`
  display: block;
  color: white;
  text-decoration: none;
  margin-bottom: 10px;
  transition: color 0.3s ease, transform 0.3s ease;
  text-shadow: 1px 1px 2px black;

  &:hover {
    color: rgb(50, 150, 88);
    transform: translateX(5px);
  }

  @media (max-width: 768px) {
    margin-bottom: 8px;
  }
`;

const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0;
  z-index: 1;
`;

const SocialIcon = styled.div`
  width: 60px;
  height: 60px;
  margin: 0 20px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  a {
    color: white;
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-decoration: none;
    transition: transform 0.3s ease, color 0.3s ease;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);

    a {
      color: rgb(255, 255, 255);
    }
  }

  @media (max-width: 768px) {
    margin: 10px;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 0;
  color: white;
  text-shadow: 1px 1px 2px black;
`;

const BottomText = styled.p`
  margin: 0;
`;

const BottomLinks = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  a {
    color: white;
    text-decoration: none;
    text-shadow: 1px 1px 2px black;

    &:hover {
      color: rgb(150, 220, 150);
    }
  }
`;

const VideoSection = styled.div`
  position: relative;
  height: 300px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center bottom; /* This moves the video upward */
  z-index: 0;
  filter: brightness(0.5);
`;
